import { Phone, UserCheck } from "lucide-react";

/**
 * A-020 P4: „Vor Ort: Rolle Name, Telefon“ – Ansprechpartner aus dem Projekt (Termin-Dialog, Monteur-App, Link für Aushilfe).
 * `kontakt` = {rolle, name, telefon, notiz, text} (Backend: utils/kunden_mailadressen.vor_ort_des_projekts); ohne Kontakt keine Zeile.
 */
const VorOrtZeile = ({ kontakt, testId = "vor-ort", klein = false }) => {
  if (!kontakt || !(kontakt.text || kontakt.telefon)) return null;
  const nummer = (kontakt.telefon || "").replace(/\s/g, "");
  return (
    <div className={`${klein ? "text-sm" : "text-sm"} flex items-start gap-1 mt-0.5 flex-wrap`} data-testid={testId}>
      <UserCheck className="w-3.5 h-3.5 mt-0.5 shrink-0" />
      <span><span className="font-medium">Vor Ort:</span> {kontakt.text}{kontakt.text && kontakt.telefon ? ", " : ""}</span>
      {kontakt.telefon && (
        <a href={`tel:${nummer}`} onClick={(e) => e.stopPropagation()} className="inline-flex items-center gap-1 text-emerald-700 font-semibold underline" data-testid={`${testId}-tel`}>
          <Phone className="w-3.5 h-3.5" />{kontakt.telefon}
        </a>
      )}
      {kontakt.notiz && <span className="text-xs text-muted-foreground w-full pl-4">{kontakt.notiz}</span>}
    </div>
  );
};

export default VorOrtZeile;
